import { Component, Input } from '@angular/core';
import posthog from 'posthog-js';
import { MenuCategory, MenuItem } from 'src/shared/models/menu.model';

@Component({
  selector: 'molecule-menu-items',
  templateUrl: './menu-items.component.html',
  styleUrls: ['./menu-items.component.scss'],
})
export class MenuItemsComponent {
  @Input() menuItemTitle: string = " ";
  @Input() menuItems!: MenuCategory;
  @Input() sectionTitle: string = "";

  onItemClick(item: MenuItem): void {
    posthog.capture(`${this.sectionTitle}: ${item.item}`, { property: 'value' });
  }
}


